import { SwitchDarkTheme } from './switch.dark-theme';
import { SwitchStyleType } from './switch.style-type';

export const SwitchLightTheme: SwitchStyleType = SwitchDarkTheme;
